import { createRoutine } from "redux-saga-routines";

export const loadAll = createRoutine("QUAR_STATS/LOAD_ALL");
export const loadOne = createRoutine("QUAR_STATS/LOAD_ONE");
